import PageLayout from "../components/UI/Layout/PageLayout";
import MonCompte from "../components/Account/MonCompte";
import Parametres from "../components/Account/Parametres";
import { Tabs } from "../components/UI/Tabs/Tabs";
import ContentLayout from "../components/UI/Layout/ContentLayout.tsx";
import Factures from "../components/Account/Factures";
import useAccount from "../hooks/use-account";
import Mandataire from "../components/Account/Mandataire";
import MailLogs from "../components/Account/MailLogs";
import Partenaires from "../components/Account/Partenaires";
import HeaderLayout from "../components/UI/Layout/HeaderLayout.tsx";
import GuidedTour from "../components/GuidedTour/GuidedTour";
import {
  PRO_COMPTE_GUIDE_ID,
  PRO_COMPTE_GUIDE_STEPS,
} from "../components/GuidedTour/guides";

export default function MonComptePage() {
  const { account } = useAccount();
  return (
    <PageLayout isBailleur>
      {account.home === "/pro" && (
        <GuidedTour
          guideId={PRO_COMPTE_GUIDE_ID}
          steps={PRO_COMPTE_GUIDE_STEPS}
        />
      )}
      <ContentLayout
        header={
          <HeaderLayout
            title={"Mon compte"}
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Mon compte" },
            ]}
          />
        }
        body={
          <Tabs id="monCompte" defaultValue="informations">
            <div className="container bg-blue paddingT10 border-blue">
              <div className="content">
                <Tabs.List>
                  <Tabs.Tab value="informations">
                    Informations générales
                  </Tabs.Tab>
                  <Tabs.Tab value="parametres">Paramètres</Tabs.Tab>
                  <Tabs.Tab value="factures">Facturation</Tabs.Tab>
                  {account.home === "/pro" && (
                    <Tabs.Tab
                      value="mandataire"
                      dataTour="compte-tab-mandataire"
                    >
                      Mandataire
                    </Tabs.Tab>
                  )}
                  <Tabs.Tab value="logs">Email envoyés</Tabs.Tab>
                  {account.partner_codes.length > 0 && (
                    <Tabs.Tab value="partenaires">Partenaires</Tabs.Tab>
                  )}
                </Tabs.List>
              </div>
            </div>
            <div className="blueSpace"></div>
            <div className="content">
              <Tabs.Panel value="informations">
                <MonCompte />
              </Tabs.Panel>
              <Tabs.Panel value="parametres">
                <Parametres />
              </Tabs.Panel>
              <Tabs.Panel value="factures">
                <Factures />
              </Tabs.Panel>
              <Tabs.Panel value="mandataire">
                <Mandataire />
              </Tabs.Panel>
              <Tabs.Panel value="logs">
                <MailLogs />
              </Tabs.Panel>
              {account.partner_codes.length > 0 && (
                <Tabs.Panel value="partenaires">
                  <Partenaires partnerCodes={account.partner_codes} />
                </Tabs.Panel>
              )}
            </div>
          </Tabs>
        }
      />
    </PageLayout>
  );
}
